module.exports = __webpack_public_path__ + "img/Group_26978.ac16bd8e.svg";